export const getNextRetry = (failCount: number) => {
    const now = new Date()

    // Try minutely for 30 minutes
    const minutelyLimit = 30
    // Try every 10 minutes for 12 hours
    const tenMinutelyLimit = 72
    // TRy every hour for 2 days
    const hourlyLimit = 48

    if (failCount <= minutelyLimit) {
        // 60000 milliseconds is one minute
        return new Date(now.getTime() + 60000)
    }

    //
    if (failCount <= minutelyLimit + tenMinutelyLimit) {
        // 600000 milliseconds is ten minutes
        return new Date(now.getTime() + 600000)
    }

    if (failCount <= minutelyLimit + tenMinutelyLimit + hourlyLimit) {
        // 3600000 milliseconds is an hour
        return new Date(now.getTime() + 3600000)
    }

    // If the fail count exceeds the cumulative limits then do not retry
    return null
}
